import { TypedDocumentNode, gql } from '@apollo/client';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useIsLoggedIn } from '@sorare/core/src/hooks/auth/useIsLoggedIn';
import { usePaginatedQuery } from '@sorare/core/src/hooks/graphql/usePaginatedQuery';

import { OfflineLanding } from '@sorare/gameplay/src/components/invite/OfflineLanding';
import { OnlineLanding } from '@sorare/gameplay/src/components/invite/OnlineLanding';

import {
  ReferralProgramConfig,
  ReferralProgramConfigVariables,
} from './__generated__/page.graphql';

const REFERRAL_PROGRAM_CONFIG = gql`
  query ReferralProgramConfig($after: String, $sport: Sport!) {
    currentUser {
      slug
      ...OnlineLanding_currentUser
    }
    config {
      id
      ...OnlineLanding_config
      ...OfflineLanding_config
    }
  }
  ${OfflineLanding.fragments.config}
  ${OnlineLanding.fragments.config}
  ${OnlineLanding.fragments.currentUser}
` as TypedDocumentNode<ReferralProgramConfig, ReferralProgramConfigVariables>;

const InvitePage = () => {
  const isLoggedIn = useIsLoggedIn();

  const { data, loadMore, loading } = usePaginatedQuery(
    REFERRAL_PROGRAM_CONFIG,
    {
      variables: { sport: Sport.FOOTBALL },
      connections: ['ReferralRewardConnection'],
    }
  );

  return isLoggedIn ? (
    <OnlineLanding
      config={data?.config}
      currentUser={data?.currentUser}
      loadMore={loadMore}
      loading={loading}
      sport={Sport.FOOTBALL}
    />
  ) : (
    <OfflineLanding config={data?.config} sport={Sport.FOOTBALL} />
  );
};

export default InvitePage;
